import { useCallback } from 'react';
import Question from './question';
import { IQuestion } from '../data/interfaces';

type Props = {
  category: string;
  questions: IQuestion[];
  hasAnswer: boolean;
  examFinished?: boolean;
  incrementResult?: (category: string, success: boolean) => void;
};

export default ({
  questions,
  category,
  hasAnswer,
  examFinished,
  incrementResult,
}: Props) => {
  const handleSelect = useCallback(
    (correct: boolean) => {
      if (examFinished) return;
      if (incrementResult) {
        incrementResult(category, correct);
      }
    },
    [examFinished, incrementResult, category]
  );

  return (
    <>
      {questions.map((question: IQuestion) => {
        return (
          <Question
            category={category}
            question={question}
            hasAnswer={hasAnswer}
            examFinished={examFinished}
            onSelect={handleSelect}
          />
        );
      })}
    </>
  );
};
